import { computed, flow, makeObservable, observable } from 'mobx';

import type { TImportJobResult, TJob } from 'src/api/import-file';
import { fetchTriplesList } from 'src/api/import-file';

import type { TTripleData } from '../../pages/import-matching-page/import-matching-page.store';

import type { IJob, JOB_STATUS } from './jobs-store';

export class ImportJob implements IJob<TImportJobResult | null> {
  @observable private data: Omit<TJob<TImportJobResult | null>, 'id'>;

  readonly id: number;

  timerId: number | null = null;

  @observable triplesWithError: TTripleData[] | null = null;

  constructor({ id, ...job }: TJob<TImportJobResult>) {
    this.data = job;
    this.id = id;

    makeObservable(this);
  }

  @flow.bound
  private async *onComplete(jobData: TJob<TImportJobResult | null>) {
    const planVersionId = jobData.jobResult?.planVersionId;

    if (planVersionId === undefined) {
      return;
    }

    const tripleList = await fetchTriplesList(planVersionId);
    yield;

    this.triplesWithError = tripleList.triples.filter((triple) => triple.hasErrors);
  }

  @computed
  get errorsCount(): number | null {
    return this.triplesWithError?.length ?? null;
  }

  @computed
  get status(): JOB_STATUS {
    return this.data.jobStatus;
  }

  @computed
  get result(): TImportJobResult | null {
    return this.data.jobResult;
  }

  @flow.bound
  async *completeJob(jobData: TJob<TImportJobResult | null>) {
    try {
      if (jobData.jobStatus === 'COMPLETED') {
        await this.onComplete(jobData);
      }
      yield;

      const { id, ...job } = jobData;
      this.data = job;
    } catch (error) {
      console.error(error);
    }
  }
}
